import React from "react";
import { isEmpty, isEqual } from "lodash";
import { getZoneFlagText, getZoneStatusText } from "utils/singleZoneCooling";

import { ZoneStatusTooltip } from "../../ZoneTooltips";

import classes from "./style.module.scss";

const ZoneStatus = React.memo(
    ({
        zoneId = "",
        changesDetected,
        hasResults,
        warnings: warningKeys = [],
        errors: errorKeys = [],
        formattedMinArea = "",
    }) => {
        const hasErrors = !isEmpty(errorKeys);
        const hasWarnings = !isEmpty(warningKeys);
        const errorMessages = errorKeys.map((key) => getZoneFlagText(key, formattedMinArea));
        const warningMessages = warningKeys.map((key) => getZoneFlagText(key));

        return (
            <React.Fragment>
                <div className={classes.status}>
                    {(changesDetected && hasResults) ? (
                        <ZoneStatusTooltip
                            id={`${zoneId}_changes_detected`}
                            status="Changes"
                            messages={[getZoneStatusText("changes")]}
                        />
                    ) : hasResults ? (
                        <ZoneStatusTooltip
                            id={`${zoneId}_has_results`}
                            status="Results"
                            messages={[getZoneStatusText("results")]}
                        />
                    ) : (
                        <ZoneStatusTooltip
                            id={`${zoneId}_no_results`}
                            status="NoResults"
                            messages={[getZoneStatusText("noResults")]}
                        />
                    )}
                </div>
                <div className={classes.status}>
                    {hasErrors ? (
                        <ZoneStatusTooltip
                            id={`${zoneId}_error`}
                            status="Error"
                            messages={[...errorMessages, ...warningMessages]}
                        />
                    ) : hasWarnings && (
                        <ZoneStatusTooltip
                            id={`${zoneId}_warning`}
                            status="Warning"
                            messages={warningMessages}
                        />
                    )}
                </div>
            </React.Fragment>
        );
    },
    isEqual
);

export default ZoneStatus;
